export const MENU_PERMISSION_BASE = 'menus:view:'